import { BehaviorSubject } from "rxjs";

const showViewIntegration = new BehaviorSubject(false);

export const integrationService = {
  viewState: showViewIntegration.asObservable(),
  open: () => showViewIntegration.next(true),
  close: () => showViewIntegration.next(false)
}